export const languagesWithCodes = [
    { name: 'English - US', code: 'en-US' },
    { name: 'Japanese', code: 'ja-JP' },
    { name: 'French - France', code: 'fr-FR' },
    { name: 'German - Germany', code: 'de-DE' },
    { name: 'Italian', code: 'it-IT' },
    { name: 'Russian', code: 'ru-RU' },
    { name: 'Spanish - Spain', code: 'es-ES' },
    { name: 'Chinese Traditional', code: 'zh-TW' },
    { name: 'Dutch', code: 'nl-NL' },
    { name: 'Portuguese', code: 'pt-PT' },
    { name: 'Chinese Simplified', code: 'zh-CN' },
    { name: 'Korean', code: 'ko-KR' },
    { name: 'Greek', code: 'el-GR' },
    { name: 'Croatian', code: 'hr-HR' },
    { name: 'Slovenian', code: 'sl-SI' },
    { name: 'Danish', code: 'da-DK' },
    { name: 'Spanish - Mexico', code: 'es-MX' },
    { name: 'Estonian', code: 'et-EE' },
    { name: 'Hungarian', code: 'hu-HU' },
    { name: 'Swedish', code: 'sv-SE' },
    { name: 'Norwegian', code: 'nb-NO' },
    { name: 'Finnish', code: 'fi-FI' },
    { name: 'Czech', code: 'cs-CZ' },
    { name: 'Turkish', code: 'tr-TR' },
    { name: 'Polish', code: 'pl-PL' },
    { name: 'English - GB', code: 'en-GB' },
    { name: 'Thai', code: 'th-TH' },
    { name: 'Vietnamese', code: 'vi-VN' },
    { name: 'Bahasa Malaysian', code: 'ms-MY' },
    { name: 'Bahasa Indonesian', code: 'id-ID' },
    { name: 'Arabic', code: 'ar-EG' },
    { name: 'Hebrew', code: 'he-IL' },
    { name: 'Romanian', code: 'ro-RO' },
    { name: 'Serbian', code: 'sr' },
    { name: 'Ukrainian', code: 'uk-UA' },
    { name: 'Latvian', code: 'lv-LV' }
];

export const addOnsLabels = [
    'AddOnPriceBreakdown.',
    'AddOnsMessageList.',
    'addOns.',
    'addOnsCategoryList.',
    'addOnsContainer.',
    'addOnsInCart.',
    'addOnsOccupancySelection.',
    'addOnsThumbCardPrice.',
    'addOnsTimeSlot.',
    'ancillaries.'
];

export const priceSummary = ['availabilityPriceBreakdown.', 'priceSummary.', 'priceSummaryCard.'];

export const rooms = [
    'productAvailability.',
    'productBasePrice.',
    'productDetailView.',
    'productDetailViewPriceBreakdown.',
    'thumbCard.',
    'roomsAndRates.'
];

export const general = [
    'resetPassword.',
    'searchHistory.',
    'searchResults.',
    'searchResultsContainer.',
    'shareSendForm.',
    'specialRequests.',
    'additionalPolicy.'
];

export const signIn = [
    'signInContainer.',
    'signInForBenefits.',
    'signInPageContainer.',
    'signInSignUpModal.',
    'signUp.',
    'userProfileSignUp.',
    'signIn.'
];

export const searchSettings = ['calendar.', 'guestQuantitiesPanel.', 'guestQuantitySelection.', 'search.'];

export const checkout = [
    'reservationDetails.',
    'reservationList.',
    'reservationPriceSummary.',
    'cancelItineraryModal.',
    'cart.',
    'cartHeader.',
    'cartReservationSummary.',
    'cartViewContainer.',
    'checkout.',
    'checkoutPolicies.',
    'cartAndCheckout.',
];

export const confirmation = [
    'confirmPolicyInfo.',
    'confirmReservations.',
    'confirmationContainer.',
    'confirmationHeader.',
    'confirmationMessage.',
    'confirmationSummary.',
    'detailView.',
    'editConfirmedReservation.'
];

export const filter = ['filterBar.', 'filterHotel.', 'filterModal.', 'filterProduct.', 'filters.'];

export const globalBar = ['globalBar.', 'userbar.', 'userbarLoggedIn.', 'userbarLogin.', 'userbarSignUp.'];

export const guestDetails = [
    'guestAddress.',
    'guestDetails.',
    'guestInfo.',
    'guestLoyalty.',
    'guestPayment.',
    'guestPaymentCreate.',
    'guestPaymentInfo.',
    'guestTransportation.',
    'packageDateRange.',
    'paymentFields.',
    'additionalGuestFields.',
    'additionalGuests.'
];

export const hotels = [
    'hotelAvailability.',
    'hotelAvailabilityPriceBreakdown.',
    'hotelDetailView.',
    'hotelPrice.',
    'login.',
    'loyaltyFields.',
    'loyaltyProgram.',
    'modalMessage.',
    'availability.'
];
const generalLabels = ['sidebar-menu', 'header'];
export const consolidatedLabels = addOnsLabels.concat(
    priceSummary,
    rooms,
    signIn,
    searchSettings,
    checkout,
    confirmation,
    filter,
    globalBar,
    guestDetails,
    hotels,
    generalLabels
);

export const widgets = [
    'shs-sbem--book-now.',
    'shs-sbem--best-price.',
    'shs-sbem--search-bar.',
    'shs-sbem--calendar.',
    'shs-sbem--generic.',
    'shs-sbem--incontext'
];



// WEBPACK FOOTER //
// ./src/constants/labelsConstants.js